// Medical History & HAVS questionnaire content.
// Question ids MUST match the canonical list in backend/medical.py —
// the backend validates every id on submission.

export const MEDICAL_QUESTIONS = [
  { id: 'm1', text: 'Are you currently receiving treatment from a doctor or hospital?' },
  { id: 'm2', text: 'Are you taking prescribed medication?' },
  { id: 'm3', text: 'Do you carry a medical warning card?' },
  { id: 'm4', text: 'Are you pregnant?' },
  { id: 'm5', text: 'Do you have any allergies?' },
  { id: 'm6', text: 'Asthma, bronchitis or any chest condition?' },
  { id: 'm7', text: 'Fainting, blackouts or epilepsy?' },
  { id: 'm8', text: 'Any heart problems?' },
  { id: 'm9', text: 'Diabetes?' },
  { id: 'm10', text: 'Bone or joint disease?' },
  { id: 'm11', text: 'Skin disease?' },
  { id: 'm12', text: 'Persistent bleeding or bruising?' },
  { id: 'm13', text: 'Liver or kidney disease?' },
  { id: 'm14', text: 'HAVS or Carpal Tunnel Syndrome (CTS)?' },
  { id: 'm15', text: 'Any other serious illness?' },
];

export const HAVS_QUESTIONS = [
  { id: 'h1', text: 'Do you have tingling after vibration exposure?' },
  { id: 'h2', text: 'Do you have tingling at other times?' },
  { id: 'h3', text: 'Night pain, tingling or numbness?' },
  { id: 'h4', text: 'Finger numbness after vibration?' },
  { id: 'h5', text: 'Fingers go white in the cold?' },
  { id: 'h6', text: 'Fingers go white at other times?' },
  { id: 'h7', text: 'Any muscle or joint problems?' },
  { id: 'h8', text: 'Difficulty handling small objects?' },
];

export const MEDICAL_CONFIDENTIALITY_NOTE =
  'Used only to identify health & safety considerations relevant to your work on PNC sites. ' +
  'Answers are visible only to authorised PNC UNIQUE LTD HR and site management staff and are ' +
  'never shared for any other purpose.';

export const MEDICAL_DECLARATION =
  'I confirm that the information I have provided in this Medical History & HAVS Questionnaire ' +
  'is true and complete to the best of my knowledge.';
